<template>
  <base-card>
    <h1>Page not found!</h1>
    <router-link to="/">Go back to home page</router-link>
  </base-card>
</template>

<style lang="scss" scoped>
h1 {
  padding: 1rem;
}
a {
  display: block;
  padding-bottom: 1rem;
}
</style>